import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PlayerSearchDialogComponent } from 'src/app/player-search-dialog/player-search-dialog.component';
import { PlayerService } from 'src/app/shared/player.service';
import { AgentViewModel } from '../../models/AgentModels';
import { AgentService } from '../../services/agent.service';
import { MatSelectionList, MatListOption, MatListModule } from '@angular/material/list';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-agent-select-dialog',
    templateUrl: './agent-select-dialog.component.html',
    styleUrls: ['./agent-select-dialog.component.css'],
  imports: [CommonModule, MatInputModule, MatDialogModule, MatSelectionList, CdkScrollable, MatListModule, MatButtonModule]
})
export class AgentSelectDialogComponent implements OnInit {

  //_agents: AgentViewModel[];
  _agents: Observable<AgentViewModel[]>;


  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AgentSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agentService: AgentService
  ) { }


  ngOnInit(): void {
    this.getAgents();
  }

  getAgents(){
    this._agents = this.agentService.getAgents();

  }

}
